import { render } from "./CallsCount.vue?vue&type=template&id=6cb6962c&scoped=true"
import script from "./CallsCount.vue?vue&type=script&lang=js"
export * from "./CallsCount.vue?vue&type=script&lang=js"

import "./CallsCount.vue?vue&type=style&index=0&id=6cb6962c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb6962c"]])

export default __exports__